import React from 'react';
import { Checkbox as AntdCheckbox, Switch } from 'antd';
import type { CheckboxProps as AntdCheckboxProps } from 'antd';

export interface CheckboxProps extends Omit<AntdCheckboxProps, 'children'> {
  label?: string;
  helperText?: string;
  error?: string;
  variant?: 'default' | 'switch';
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  helperText,
  error,
  variant = 'default',
  className = '',
  ...props
}) => {
  if (variant === 'switch') {
    const { onChange, checked, ...switchProps } = props;
    return (
      <div className={className}>
        <Switch
          checked={checked}
          onChange={(checked) => onChange?.({ target: { checked } } as any)}
          {...switchProps as any}
        >
          {label}
        </Switch>

        {(helperText || error) && (
          <div className={`mt-1 text-xs ${error ? 'text-red-500' : 'text-gray-500'}`}>
            {error || helperText}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      <AntdCheckbox {...props}>
        {label}
      </AntdCheckbox>

      {(helperText || error) && (
        <div className={`mt-1 text-xs ${error ? 'text-red-500' : 'text-gray-500'}`}>
          {error || helperText}
        </div>
      )}
    </div>
  );
};

export default Checkbox;
